import React, { FC } from "react";
import { FinancialConnection } from "../../../common/types/financialConnection";
import { FinancialAccount } from "../../../common/types/financialAccount";
import { GridTableRow } from "../../general/Tables/GridTable/GridTable";
import { IntegrationConnectionIcon } from "../../financialConnection/FinancialConnectionIcon";
import { getAccountNameWithLast4 } from "../../../common/helpers/financialAccount";
import styles from "./ReconnectAccounts.module.scss";

interface AccountRowProps {
    connection: FinancialConnection;
    account: FinancialAccount;
}

export const AccountRow: FC<AccountRowProps> = ({ connection, account }) => (
    <GridTableRow>
        <div className={styles.account}>
            <div className={styles.icon}>
                <IntegrationConnectionIcon
                    connection={connection}
                    account={account}
                />
            </div>
            {getAccountNameWithLast4(account, 2)}
        </div>
    </GridTableRow>
);
